import { render, staticRenderFns } from "./VerMisBookingPorAceptar.vue?vue&type=template&id=12b01657"
import script from "./VerMisBookingPorAceptar.vue?vue&type=script&lang=js"
export * from "./VerMisBookingPorAceptar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports